import { createFileRoute } from '@tanstack/react-router'

import { PrivacyPolicyPage } from '@/features/legal'
import { buildPageTitle } from '@/shared/lib/page-title'

export const Route = createFileRoute('/politica-de-privacidade')({
  head: () => ({
    meta: [{ title: buildPageTitle('Política de Privacidade') }]
  }),
  component: PrivacyPolicyPage
})
